import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActiveModal } from '../../classes/active-modal';
import { ModalComponent } from '../modal/modal.component';
import { Observable } from 'rxjs/Observable';
import { MODAL_DISMISS_REASONS } from '../../modal-dismiss-reasons';
import { trans } from '../../../localization';
import { ActiveModalButtons } from '../../classes/active-modal-buttons';
import { ActiveModalLoader } from '../../classes/active-modal-loader';

@Component({
    selector: 'form-modal',
    templateUrl: './form-modal.component.html',
    styleUrls: ['./form-modal.component.scss']
})
export class FormModalComponent extends ModalComponent implements OnInit, OnDestroy {

    public loading: Observable<boolean>;

    /**
     * The modal's form handler instance.
     *
     * @type {ChassisFormHandler}
     */
    @Input() public form;

    constructor(public modal: ActiveModal, public buttons: ActiveModalButtons, public loader: ActiveModalLoader) {
        super(modal, buttons, loader);

        this.setLoader();

        this.addButtons();
    }

    protected setLoader() {
        this.modal.set('loading', this.loader);
    }

    protected addButtons() {
        super.addButtons();

        this.buttons.replace('ok', {
            text: trans('Save'),
            icon: 'fas fa-check',
            classes: 'btn-primary',
            callback: () => {
                this.submit();
            }
        });
    }

    ngOnInit() {
        super.ngOnInit();

        this.setUpForm();

        // this.modal.beforeClose((formResolve, formReject, formResult) => {
        //     console.log('beforeClose');
        //
        //     this.startLoading();
        //     console.log(this.form);
        //
        //     this.form.success((result, resolve) => {
        //         console.log('formSuccess');
        //
        //         this.stopLoading();
        //
        //         resolve(result);
        //
        //         formResolve(result);
        //     });
        //
        //     this.form.error(() => {
        //         this.stopLoading();
        //     });
        // });
    }

    private setUpForm() {
        if (!this.containsFormHandler()) {
            this.form = this.modal.get<any>('form');
        }

        if (!this.containsFormHandler()) {
            this.dismiss(MODAL_DISMISS_REASONS.ERROR);

            throw new Error('The form could not be opened because no form instance was set, please set a form instance.');
        }

        this.form.success((result, resolve, reject) => {
            resolve(result);
        });

        this.form.afterSuccess((result: any) => {
            this.close(result);
        });

        this.form.error(() => {
            this.loader.stop();
        });

    }

    private containsFormHandler() {
        return !!this.form && this.form['success'] instanceof Function && this.form['error'] instanceof Function;
    }

    /**
     * Submit the form.
     */
    public submit(): void {
        this.loader.start();

        this.form.submit();
    }

    ngOnDestroy() {
        this.modal.dismiss();
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/components/form-modal/form-modal.component.ts